import clsx from "clsx";
import st from "@/styles/Ui.module.scss";

interface Props {
    onClick(e:any):void
    className?:string
}

const ClickableBgOverlay:React.FC<Props> = ({onClick, className}) => {
    
    
    return (
        <div
            className={clsx(st.overlay_element, className && className)}
            onClick={onClick}
        />
    )
}

export default ClickableBgOverlay